import _ from 'lodash';
import moment from 'moment';
import BN from 'bignumber.js';
import { React, PT, fetchApi } from '@gasbuddy/react';
import { Header, Modal, Button, Form, Table, Dropdown, Dimmer, Loader } from 'semantic-ui-react';

function date(d) {
  return d ? moment(d).format('MM/DD/YY HH:mm') : '-';
}

function name(programs, id) {
  return programs.find(p => p.payment_program_id === id).program_name;
}

function desc(p) {
  const steady = new BN(p.per_gallon_discount).toFixed(2);
  const counterparty = (p.extra_data && p.extra_data.counterparty)
    ? `(counterparty ${p.extra_data.counterparty}) ` : '';
  if (p.initial_per_gallon_discount) {
    const initial = p.initial_per_gallon_discount
      ? new BN(p.initial_per_gallon_discount).toFixed(2) : steady;
    return `${p.program_name} ${counterparty}($${initial} first/$${steady} after)`;
  }
  return `${p.program_name} ${counterparty}($${steady} always)`;
}

function isAssignable(p, history) {
  return p.extra_data && (p.extra_data.can_assign
    || (p.extra_data.is_membership && _.find(history, h => h.payment_program_id === p.payment_program_id))
    || (p.extra_data.counterparty === 'syw' && _.find(history, h => h.payment_program_id === p.payment_program_id)));
}

export class ProgramModal extends React.Component {
  state = {}

  loadAndGo = () => {
    const { accountId } = this.props;
    this.setState({ opened: true, loading: true }, async () => {
      const { body } = await fetchApi({
        url: '/payments/programs',
        body: { account_id: accountId },
      });
      this.setState({ loading: false, ...body });
    });
  }

  changeProgram = (e) => {
    e.preventDefault();
    const { newProgram } = this.state;
    const { accountId, onUpdate } = this.props;
    if (newProgram) {
      this.setState({ loading: true }, async () => {
        await fetchApi({
          url: `/payments/programs/${accountId}`,
          body: { program_name: newProgram },
        });
        if (onUpdate) {
          onUpdate();
        }
        this.setState({ opened: false, loading: false, newProgram: null });
      });
    }
  }

  render() {
    const { opened, loading, history = [], programs = [] } = this.state;
    return (
      <Modal
        open={opened}
        trigger={<Button onClick={this.loadAndGo} size="mini" floated="right">Change</Button>}
      >
        <Header content="Change Payment Program" />
        <Modal.Content>
          <Dimmer.Dimmable dimmed={loading}>
            <Dimmer active={loading}>
              <Loader />
            </Dimmer>
            <div>
              <h3>Program History</h3>
              <Table>
                <Table.Header>
                  <Table.Row>
                    <Table.HeaderCell>Program Name</Table.HeaderCell>
                    <Table.HeaderCell>Created</Table.HeaderCell>
                    <Table.HeaderCell>Activated</Table.HeaderCell>
                    <Table.HeaderCell>Deleted</Table.HeaderCell>
                    <Table.HeaderCell>Initial Tx Ct</Table.HeaderCell>
                  </Table.Row>
                </Table.Header>
                <Table.Body>
                  {history.map(p => (
                    <Table.Row key={p.payment_program_id}>
                      <Table.Cell>{name(programs, p.payment_program_id)}</Table.Cell>
                      <Table.Cell>{date(p.created)}</Table.Cell>
                      <Table.Cell>{date(p.activated_at)}</Table.Cell>
                      <Table.Cell>{date(p.deleted_at)}</Table.Cell>
                      <Table.Cell>{p.initial_discount_counter}</Table.Cell>
                    </Table.Row>
                  ))}
                </Table.Body>
              </Table>
              <Form>
                <Form.Field>
                  <Dropdown
                    placeholder="Select the new Program"
                    options={programs.filter(p => isAssignable(p, history)).map(p => ({
                      value: p.program_name,
                      text: desc(p),
                    }))}
                    onChange={(e, el) => this.setState({ newProgram: el.value })}
                    search
                    selection
                  />
                </Form.Field>
              </Form>
            </div>
          </Dimmer.Dimmable>
        </Modal.Content>
        <Modal.Actions>
          <Button basic color="grey" onClick={() => this.setState({ opened: false })}>
            Cancel
          </Button>
          <Button basic color="red" onClick={this.changeProgram}>
            Change Program
          </Button>
        </Modal.Actions>
      </Modal>
    );
  }
}

ProgramModal.propTypes = {
  accountId: PT.number,
  onUpdate: PT.func,
};

ProgramModal.defaultProps = {
  accountId: 0,
  onUpdate: null,
};
